/**
@ngdoc directive
@name xmsValidation

@description
Form fields validation messages.<br />
It uses the field's html5 attributes (Angular validation) to perform validation and populate {values} into messages.<br />
It will add the validationErrorClass to the validated form field and then attach the translated and compile error messages.<br />
Error messages may APPEND the field's wrapping container ('form-group' by default) or may be inserted directly AFTER the field.<br />
It works directly on the form element OR as a decorator on the wrapping container (ie. in case the element has already isolated scope directive applied).<br />
<br />
Please mind that the element has to have name attribute defined!!!<br />
Please mind!! Once you create the correct HTML there should be no need for the parameters below apart from validation-messages!

@param {string=} validationErrorClass 	error class we attach to the wrapping element (Bootstrap 3 'has-error' by default)<br />
						  	  			you probably never will want to set this parameter in XMS
@param {string=} validationWarningClass warning class we attach to the wrapping element (Bootstrap 3 'has-warning' by default)<br />
						  	  			you probably never will want to set this parameter in XMS
@param {string=} validationSuccessClass	as above, 'xms-has-success' by default
@param {Object=} validationMessages 	custom validation messages<br />
						  	  			ie. validation-messages={min:'Value needs to be greater than {value}', max:'Value must be lower that {value}'}<br />
						      			The directive will automaticaly replace {value} with the attributes values (not dynamic)
@param {unsure=} validationWarnings 	instead of giving form error you may give the warning. The form will still pass the validation, but
							  			warning message will be shown to the user
@param {string=} validationWrapperClass (Bootstrap 3 'form-group' by default) the element we add validationErrorClass for the whole field
						      			if no wrapper found the error class added directly on the element<br />
						      			in xms we use it only for horizontal forms
@param {any=} validationWrapper 		TODO: alias of above
@param {string=} messagesWrapperClass 	(Bootstrap 3 'form-group' by default) the element we append with validation messages<br />
						      			if no wrapper found the messages will be inserted after validated form field<br />
						      			in xms we only use it for horizontal forms
@param {any=} validationMessagesWrapper	TODO: alias of above
@param {selection=} validationMessagesPosition [append | after] ('append' by default) you may enforce placing messages 'after'
									the field instead of 'append'-ing the field container

@example
Please refer to testUi (former testValidation) file for for multiple examples
*/
(function() {

	'use strict';

    var xmsValidation = function($compile, $translate, $timeout, formFieldFactory) {
		return {
			restrict: 'A',
			scope: true,
			bindToController: {
				validationMessages:"&",
				validationWarnings:"@"
			},
			controllerAs:"ctrl",
			controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

				var _this = this;

				this.$onInit = function(){
					if($attrs.xmsValidation=="false") { // validation disabled
						return;
					}
					// default validation messages - they all will get translated by angular-translate
					$scope.errorMessage = { "email":"email", "minlength":"minlength", "maxlength":"maxlength", "min":"min", "max":"max",
						"required":"required", "date":"date", "pattern":"pattern",	"number":"number", "url":"url", "time":"time", "editable":"editable",
						"maxminutes":"maxminutes", "maxmonths":"maxmonths" };

				    // you may enforce placing messages 'after' the field instead of 'append'-ing the field container (generally rather not in use)
				    this.messagesPosition = ($attrs.validationMessagesPosition=='after') ? 'after' : 'append';

				    // set default Bootstrap3 'form-group' class if not defined
				    this.validationWrapperClass = $attrs.validationWrapperClass || 'form-group'; // TODO: config
				    this.messagesWrapperClass   = $attrs.messagesWrapperClass   || 'form-group'; // TODO: config // TODO: replace with 'msg-box' !!

				    // default validationErrorClass if not defined
				    this.validationErrorClass   = $attrs.validationErrorClass   || 'has-error'; // TODO: config
				    this.validationWarningClass = $attrs.validationWarningClass || 'has-warning'; // TODO: config
				    this.validationSuccessClass = $attrs.validationSuccessClass || 'xms-has-success'; // TODO: config


			    	if(angular.isDefined(this.validationWarnings) && this.validationWarnings!='' ) {
			    		_this.warnings = commaSplitAndTrim(_this.validationWarnings);
			    	}
			    }

			    function commaSplitAndTrim(string){
		    		return string.match( /(?=\S)[^,]+?(?=\s*(,|$))/g );
		    	}
			}],
			require: ["xmsValidation", "^form"], // require both controllers
			link: function (scope, el, attrs, ctrls) {

				if(attrs.xmsValidation=="false") {
					return;
				}

				var ctrl   		= ctrls[0];
				scope.form 		= ctrls[1];

				// TODO: scope.$evalAsync ????
				$timeout(function(){ // timeout is necessary for dynamic field names

					// xms-validation can be applied on parent element, so we need to determine the form field
					var elField = formFieldFactory.searchElementDOM(el);

					// apply custom messages (validation-messages) into error messages
					scope.errorMessage = pepareCustomMessages(elField, ctrl.validationMessages, scope.errorMessage);

					// this is in case the validation options been applied to the field not to the parent
					// specfically it's been done for xms-autocomplete
					// TODO: remove after some time
					if( elField != el ) {
						if( elField.attr('validation-messages-class') && !attrs.messagesWrapperClass ) {
							// ctrl.messagesWrapperClass = elField.attr('validation-messages-class');
							throw 'xms-validation: Placing xms-validation on xms-autocomplete parent has been removed. Please place both on the same element.';
						}
					}

					// based on fieldName we can access the field
					// this is actually ngModelCtrl of the field!!!
					var ngModelCtrl = scope.formField = scope.form[ elField.attr('name') ];

					if(angular.isDefined(ctrl.warnings) && ctrl.warnings.length > 0 ){ // needed only for warnings
						var initialAllowInvalid = ngModelCtrl.$options.getOption('allowInvalid'); // store for reverting to the state
					}

					// the following allows to use xms-validation as a wrapper

					// messagesWrapper is the element we append validation messages into (or append to if it's actual field)
					var messagesWrapper;

					if( ctrl.messagesPosition == 'append' || angular.isDefined(attrs.messagesWrapperClass) ) {
						// if 'append' (default 'form-group') or messagesWrapperClass explicitly defined on after
						messagesWrapper = elField.closest('.'+ctrl.messagesWrapperClass);

						// TODO: once 'msg-box' added everywhere it can be removed !!
						var msgBox = messagesWrapper.find('.msg-box');
						messagesWrapper = ( msgBox.length && !angular.isDefined(attrs.messagesWrapperClass) ) ? msgBox : messagesWrapper;
					}
					if(!angular.isDefined(messagesWrapper) || !messagesWrapper.length) {
						messagesWrapper = elField;
						ctrl.messagesPosition = 'after'; // you cannot really append the form field
					}

					// get the messages template
					var templateMessages = prepareTemplate(elField);

					// if there are any messages (if the field will validate at any point)
					if( templateMessages ) {
						// compile messages template
		        		var compiledMessages = $compile( templateMessages )( scope );

			        	// now we need to attach the error messages template
			        	if( ctrl.messagesPosition=='append' ){
			        		// add the messages at the end of it's content (append)
			        		messagesWrapper.append( compiledMessages );
			        	} else {
			        		// else add the messages after
			        		messagesWrapper.after( compiledMessages );
			        	}


		        		// wrapper is the element we add error class for the whole element
		        		// this is usually div class="form-group" in Twitter Bootstrap
		        		var wrapper = el.hasClass(ctrl.validationWrapperClass) ? el : el.closest('.'+ctrl.validationWrapperClass);
			        	// add parent decorator
						if(!wrapper.length) {
		                	// this is not really required as we already have .ng-invalid in case we need that (?)
		                	// well, maybe... - but what if xms-validation is on wrapper and there is no 'form-group' class
		                	wrapper = el;
		                }

		                // just toggle class as delay supposed be set by ng-model-options debounce
						var unbindWatch = scope.$watch(invalidCondition, function( newVal, oldVal ) {
		                	if(newVal != oldVal){

		                		if( angular.isDefined(newVal) ){
			                		if(newVal < 0) {
			                			wrapper.removeClass(ctrl.validationSuccessClass);
			                			wrapper.addClass(ctrl.validationErrorClass);
			                		} else {
			                			wrapper.removeClass(ctrl.validationErrorClass);
			                			if(newVal > 0){ // only if 1 (valid)
			                				wrapper.addClass(ctrl.validationSuccessClass);
			                			} else {
			                				wrapper.removeClass(ctrl.validationSuccessClass);
			                			}
			                		}
			                	}

			                	// warnings
			                	if(angular.isDefined(ctrl.warnings) && ctrl.warnings.length > 0 ){
			                		warningToggle(wrapper, ngModelCtrl, initialAllowInvalid);
			                	}

		                	}
		                });
		                // destroy
		                scope.$on('$destroy', function(){
		                	unbindWatch();
		                });

		                // validation initial check
		                var initialCheck = invalidCondition(scope);
		                if(initialCheck > 0){
		                	wrapper.addClass(ctrl.validationSuccessClass);
		                } else if(initialCheck < 0){
		                	/* this is required for dynamically added fields ie. new rows in xmsTable
		                	(otherwise the error wouldn't be shown on adding new row and having the form already submitted) */
		                	wrapper.addClass(ctrl.validationErrorClass);
		                }

		                // warnings
						if(angular.isDefined(ctrl.warnings) && ctrl.warnings.length > 0 ){

							if(angular.isDefined( elField.attr('xms-datepicker') )) {
								// uib-datepicker-popup manipulates model while the field is invalid hence this will not work with warnings...
								throw "Error: Validation Warnings will not work correctly with Angular UI Bootstrap (uib-datepicker-popup which is part of xms-datepicker). Please remove the warnings.";
							}

							// [required] red border css fix (adding new class)
							if( ctrl.warnings.indexOf('required') > -1 ){
								wrapper.addClass('warning-required');
							}

							// warning check - out of invalidCondition change as just an error type may change
							// unfortunately for warnings we also need to watch the $error type and switch between warning and error classes
		                	// (it's basically ngModelCtrl.$error watch)
		                	// TODO: is there any optimisation possible??
							var unbindWatch2 = scope.$watchCollection('formField.$error', function(newVal, oldVal) {
								if(newVal != oldVal){
									warningToggle(wrapper, ngModelCtrl, initialAllowInvalid);
								}
							});
							// destroy
							scope.$on('$destroy', function(){
		                		unbindWatch2();
		                	});

		                	// warnings initial check
							if(Object.keys(ngModelCtrl.$error).length !== 0){
								var isWarning = warningCheck(ctrl.warnings, ngModelCtrl.$error);

								if(isWarning) {
									if(initialAllowInvalid!==true){
										ngModelCtrl.$options.$$options.allowInvalid = true; // scope.formFields is ngModelCtrl
									}
									formFieldFactory.formUnregister(ngModelCtrl, scope.form);
								} else {
									if(initialAllowInvalid!==true){
										ngModelCtrl.$options.$$options.allowInvalid = initialAllowInvalid; // scope.formFields is ngModelCtrl
									}
									formFieldFactory.formRegister(ngModelCtrl, scope.form);
								}
							}

						}

		                // accessibility
		                // elField.attr('aria-describedby', elField.attr('name')+'.error');


		                // trigger validation if the field is not empty!
		                // we still need angular.isDefined(ngModelCtrl) as the field can be excluded from validation, hence ngModelCtrl removed
		                if( angular.isDefined(ngModelCtrl) && angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue!='' ){
		                	formFieldFactory.triggerDependantFieldValidation(ngModelCtrl);

		                	// remove modelValue if the field is invalid
		                	if( ngModelCtrl.$invalid && !ngModelCtrl.$options.getOption('allowInvalid') ){
		                		ngModelCtrl.$modelValue = undefined;
								ngModelCtrl.$$writeModelToScope();
		                	}
		                }

		                // this would not work on any element xms-validation was applied to the parent
		                /*if( angular.isDefined(ngModelCtrl) && ngModelCtrl!=null ){
		                	if( angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue!='' ){
		                		formFieldFactory.triggerDependantFieldValidation(scope.formField);
		                	}
		                } else {
		                	console.log('ngModel undefined!');
		                	console.log( elField[0] );
		                	console.log( scope.formField );
		                }*/

	                }

				},0); // timeout end


				/*** Functions declarations ***/

				var pepareCustomMessages = function(elField, validationMessages, errorMessages){
					// messages for input type="date"
					if(elField.attr('type') == 'date'){
						errorMessages.min = 'mindate';
						errorMessages.max = 'maxdate';
						if(cssua.ua.chrome) {
							// Chrome message without date format as it's field native
							errorMessages.date = "dateChrome";
						}
					}
					// add or replace with custom validation messages (also will get translated on the fly if needed)
					if( angular.isDefined(validationMessages) ) {
						angular.forEach(validationMessages(), function(value, key){
					    	if(value!=""){ // if string not empty
					    		errorMessages[key] = value;
			    			}
					    });
					}
					return errorMessages;
				}


				// validation condition
				function invalidCondition(scope){
					if(!angular.isDefined(scope.formField)){
						return undefined; // if !isDefined(form) skip the form condition (?) // excluded field?
						// this was required for the complex field inside ng-if ie. XMS-6783
						/* specifically (inside ng-if):
						<input class="form-control " type="number" name="principalChargeRate"
        					id="principalChargeRate" ng-model="formModel.principalChargeRate"
        	 				xms-validation
        					min="0" step="0.01"
        					ng-required="true" ng-readonly="true" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/"
            				aria-label="Charge Rate" ng-min="formModel.payRate" validation-messages="{min: 'Charge Rate must be more than Pay Rate'}" bootstrapCol="6"  />
        				*/
					}
					var returnVal;
					if( (angular.isDefined(scope.formField.$invalid) && !scope.formField.$invalid) ){
						returnVal = 1; // valid
					} else if (scope.form.$submitted || scope.formField.$touched || scope.formField.$dirty) {
						returnVal = -1; // invalid (and submitted or touched/dirty) => show error
					} else {
						returnVal = 0; // invalid, but don't show anything yet
					}
					return returnVal;
					/* the whole concept could be replaced at some point by .has-error .field-touched classes (two watches: $invalid and $touched)
					so the error is shown .ng-submitted .has-error or .field-touched.has-error (see testWidgets comments) */
				}


				function warningCheck(arrayWarnings, formFieldErrors){

					var errorsNum   = Object.keys(formFieldErrors).length;
					var warningsNum = _.intersection( arrayWarnings, Object.keys(formFieldErrors) ).length;
					// true if warningNum is equal to all errors number - otherwise there are more errors than warnings and error validation should be triggered
					return (warningsNum == errorsNum) ? true : false;
					/*var isWarning = false;
					angular.forEach(arrayWarnings, function(warning){ // TODO: convert into some nice one-liner if possible (see below)
						if(angular.isDefined(formFieldErrors[warning])){
							isWarning = true;
						}
					});
					return isWarning;*/

					/* ES2016: (intersection)
					let a = ['a', 'b', 'c'];
					let b = ['c', 'a', 'd'];
					a.some(v => b.includes(v));
					*/
				}


				function warningToggle(wrapper, ngModelCtrl, initialAllowInvalid){

					if(Object.keys(ngModelCtrl.$error).length === 0){ // if ngModelCtrl.$error is empty object (no errors)

						wrapper.removeClass(ctrl.validationWarningClass);
						// in this case the rest ('has-success'/'has-error') will be handled by invalidCondition watch

						if(initialAllowInvalid!==true){
							ngModelCtrl.$options.$$options.allowInvalid = initialAllowInvalid; // restore allowInvalid
						}
					} else {
						var isWarning = warningCheck(ctrl.warnings, ngModelCtrl.$error);

						if(isWarning) {

							if(initialAllowInvalid!==true){
								ngModelCtrl.$options.$$options.allowInvalid = true;

								// the following will not work for xms-datepicker (as it resets invalid values)
								var modelValue = ngModelCtrl.$viewValue;
								angular.forEach(ngModelCtrl.$parsers, function (parser) {
									modelValue = parser(modelValue);
								});
								ngModelCtrl.$modelValue = modelValue;

								ngModelCtrl.$$writeModelToScope();
							}

							wrapper.removeClass(ctrl.validationErrorClass);
							wrapper.addClass(ctrl.validationWarningClass);
							// unregister field from the form, so it's valid despite the warning
							formFieldFactory.formUnregister(ngModelCtrl, scope.form);
						} else {

							if(initialAllowInvalid!==true){
								ngModelCtrl.$options.$$options.allowInvalid = initialAllowInvalid;
								ngModelCtrl.$modelValue = undefined;
								ngModelCtrl.$$writeModelToScope();
							}

							// no warning, but the error is still there
							wrapper.removeClass(ctrl.validationWarningClass);
							wrapper.addClass(ctrl.validationErrorClass);
							// register field back into the form
							formFieldFactory.formRegister(ngModelCtrl, scope.form)
						}
					}
				}


				function pad(n) {
					return n < 10 ? "0"+n : n;
				}

				// translates and prepares the messages template
				var prepareTemplate = function(field){

					// get all (DOM) attributes of the field
					var fieldAttrs = new Array();
					var fieldAttrsKeys = new Array(); // we need second array for optimization below
					var attr;
					angular.forEach(field[0].attributes, function(val, key) {
						attr = val.nodeName.toLowerCase(); // for some reason IE9 replaces maxlength with maxLength (with capital L) hence toLowerCase()
						// key = attrs.$normalize(key);
						// we may think of normalization (camelCase), need to rememeber about validation-remote and natural-number and all messages for these two
						if(val.nodeValue!=""){
							fieldAttrs[attr] = val.nodeValue;
						}
						fieldAttrsKeys.push( attr.replace('ng-','') ); // normalized keys
					});
					fieldAttrsKeys.push(fieldAttrs['type']);

					// the url validation should be only if the field type="url" not one of attributes
					// (this is specifically for ajax-helper url attribute in conjuction with validation)
					// TODO: should it be done for other types?
					if(fieldAttrs['type']!=='url'){
						if(fieldAttrsKeys.indexOf('url') >= 0){
							// if type!=url remove 'url'
							fieldAttrsKeys.splice(fieldAttrsKeys.indexOf('url'),1);
						}
					}

					// native Chrome date format for the validation message
					if(cssua.ua.chrome && field.attr('type') == 'date'){
						try {
							if( angular.isDefined(fieldAttrs['min']) ){
								fieldAttrs['min'] = (new Date( fieldAttrs['min'] )).toLocaleDateString('en-GB');
							}
							if( angular.isDefined(fieldAttrs['max']) ){
	   							fieldAttrs['max'] = (new Date( fieldAttrs['max'] )).toLocaleDateString('en-GB');
							}
						} catch(e) { // in case toLocaleDateString giving "Unsupported time zone specified undefined" error

							if( angular.isDefined(fieldAttrs['min']) ){
								var dateobj = new Date( fieldAttrs['min'] );
								fieldAttrs['min'] = pad(dateobj.getDate())+"/"+pad(dateobj.getMonth()+1)+"/"+dateobj.getFullYear();
							}
							if( angular.isDefined(fieldAttrs['max']) ){
	   							var dateobj = new Date( fieldAttrs['max'] );
	   							fieldAttrs['max'] = pad(dateobj.getDate())+"/"+pad(dateobj.getMonth()+1)+"/"+dateobj.getFullYear();
							}
						}
					}
					// optimization - calculate only validation messages which are in use to avoid to many watchers
					var keysIntersection = _.intersection( fieldAttrsKeys, Object.keys(scope.errorMessage) ); // it will work in lodash too
					return keysIntersection.length ? createTemplate(keysIntersection, fieldAttrs) : false;
				}


				var createTemplate = function(keysIntersection, fieldAttrs){

					var messagesTemplate = [
						'<span class="help-block validation-messages" ng-messages="formField.$error">'
					];

					// validation-remote validation message returned from the server (as data.response)
					if( angular.isDefined(attrs.validationRemote) && angular.isDefined(attrs.remoteValidationMessage) ){
						if(attrs.remoteValidationMessage=="true"){
							keysIntersection.splice(keysIntersection.indexOf('validation-remote'), 1);
							messagesTemplate.push('<small ng-message="validation-remote">{{remoteValidationErrorMsg}}</small>');
						}
					}

					var translateValue;
					angular.forEach(keysIntersection, function(key){
						translateValue = ( angular.isDefined(fieldAttrs[key]) ) ? ':{'+attrs.$normalize(key)+':\''+fieldAttrs[key].replace("'","\\\'")+'\'}' : '';
						messagesTemplate.push(
							['<small role="alert" aria-live="assertive" ng-message="'+key+'">',
								'{{\''+scope.errorMessage[key].replace("'","\\\'")+'\' | translate'+translateValue+' }}',
							'</small>'].join('')
							// we need to escape single quotes hence replace everywhere (replaces ' with \')
						);
					});
					messagesTemplate.push('</span>');
					return messagesTemplate.join('');
				}

  			} // link end
    	}
    }
    xmsValidation.$inject = ['$compile', '$translate', '$timeout', 'formFieldFactory'];
    angular.module('app').directive('xmsValidation', xmsValidation);

}());